import { keys, filter as _filter, find, get, pickBy, mapValues, isArray, chain, isEmpty } from "lodash"
import { createSelector } from "reselect"
import { getCountries, getCurrencies, getClassificationFacetTrees } from "modules/watchlist-facets/selectors"
import { getFilter } from "."

const getCountryFacets = state => state.modules.watchlistFacets.country
const getCurrencyFacets = state => state.modules.watchlistFacets.currency
const getClassificationFacets = state => state.modules.watchlistFacets.classifications

export const getWatchlistFacetSecuritiesCount = state => get(state, "global.data.watchlistFacets.data.model.securitySearch.count", null)

export const getClassificationFilteredFacets = createSelector(
  [getClassificationFacets, getClassificationFacetTrees],
  (classificationFacets, availableClassifications) => mapValues(classificationFacets, (c, cId) =>
    pickBy(c, (f, fId) =>
      get(availableClassifications, [cId, f.tier, "facets", fId]),
    ),
  ),
)

export const getFacetedFilter = createSelector(
  [getFilter, getCountryFacets, getCurrencyFacets, getClassificationFilteredFacets, getCountries, getCurrencies],
  (filter, countryFacets, currencyFacets, classificationFacets, availableCountries, availableCurrencies) => {
    let query = { ...filter }

    let countries = keys(countryFacets)
    countries = _filter(countries, c => find(availableCountries, ac => ac.id === c))
    if (countries.length) {
      query.country = {
        in: countries,
      }
    }

    let currencies = keys(currencyFacets)
    currencies = _filter(currencies, c => find(availableCurrencies, ac => ac.id === c))
    if (currencies.length) {
      query.currency = {
        in: currencies,
      }
    }

    const classificationsFacetsFilter = chain(classificationFacets)
      .map((classification, id) => ({
        id,
        in: chain(classification)
          .map((facet, facetId) => ({ value: facetId, ...facet }))
          .filter(({ selected }) => selected)
          .map(({ value, tier }) => ({ value, tier }))
          .value(),
      }))
      .filter((cFilter) => !isEmpty(get(cFilter, "in")))
      .value()

    let existingClassifications = get(query, "classification", [])
    if (!isArray(existingClassifications)) {
      existingClassifications = [existingClassifications]
    }
    query = {
      ...query,
      classification: [
        ...existingClassifications,
        ...classificationsFacetsFilter,
      ],
    }

    return query
  },
)

export const getFacetedFilterId = createSelector(
  [getFacetedFilter],
  filter => JSON.stringify(filter),
)
